import { ParagraphWrapper } from '../paragraph/style';
import { VideoWrapper } from './style';
import { getStrapiMediaURL, isMediaCrossOrigin } from '../../../lib/media';

const Video = ({ block, documentData, pageType }) => {

  const alignment = block.alignment || 'Mittig';

  const videoUrl = getStrapiMediaURL(block.media?.data?.attributes?.url ?? block.video?.data?.attributes?.url);
  const posterUrl = getStrapiMediaURL(block.thumbnail?.data?.attributes?.url);
  const subtitlesUrl = getStrapiMediaURL(block.subtitles?.data?.attributes?.url);

  return (
    <VideoWrapper alignment={alignment}>
      {videoUrl && (
        <video
          width="100%"
          controls
          title={block.media?.data?.attributes?.alternativeText ?? ''}
          poster={posterUrl ?? undefined}
          preload="metadata"
          crossOrigin={isMediaCrossOrigin() ? 'anonymous' : undefined}
        >
          <source src={videoUrl}></source>

          {subtitlesUrl && (
            <track
              kind="captions"
              src={subtitlesUrl}
              srcLang="de"
              label="Deutsch"
              default
            />
          )}

        </video>
      )}
      {(block.description || block.videoDescription) && (
        <ParagraphWrapper>
          <p className="small-text">{block.description ?? block.videoDescription}</p>
        </ParagraphWrapper>
      )}
    </VideoWrapper>
  );
};

export default Video;
